interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={`${isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}`}>
      <div className={`flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`}>
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 font-heading text-xs font-bold text-background-50 dark:text-foreground-950">
          {index}
        </span>
        <span className="font-label text-xs font-bold uppercase tracking-[0.2em] text-primary-700">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[34px]">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
      ) : null}
    </div>
  );
}